import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import * as moment from 'moment';
import { DoctorDashboardService } from 'src/app/services/doctor-dashboard.service/doctor-dashboard.service';

@Component({
  selector: 'app-chart-patient-periode',
  templateUrl: './chart-patient-periode.component.html',
  styleUrls: ['./chart-patient-periode.component.css']
})
export class ChartPatientPeriodeComponent  implements OnInit, AfterViewInit {
  @ViewChild('patientPeriodeCanvas') patientPeriodeCanvas!: ElementRef;

  private chart!: Chart;
  private chartInitialized = false;

  public rdvs: Array<number> = [];

  startDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1);
  finDate: Date = new Date();

  constructor(
    private doctorDashboardService: DoctorDashboardService,
    private ngZone: NgZone
  ) {}

  get canvasContext(): any {
    return this.patientPeriodeCanvas.nativeElement.getContext('2d');
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.staticPatient();
      this.chartInitialized = true;
    });
  }

  staticPatient() {
    if (!this.patientPeriodeCanvas) return; // guard important

    const startDate = new Date(this.startDate).getTime();
    const endDate = new Date(this.finDate).getTime();

    this.doctorDashboardService.staticPatient(startDate, endDate).subscribe((res) => {
      this.chart?.destroy(); // détruire l'ancien chart si existant

      this.chart = new Chart(this.canvasContext, {
        type: 'line',
        data: {
          labels: res.map((elm) =>
            moment(new Date(elm.creationDate)).format('DD/MM/YYYY')
          ),
          datasets: [
            {
              label: `Nombre de Patients Entre ${moment(startDate).format('DD/MM/YYYY')} Et ${moment(endDate).format('DD/MM/YYYY')}`,
              data: res.map((elm) => elm.pCount),
              fill: true,
              backgroundColor: 'transparent',
              borderColor: 'rgba(168, 50, 117, 1)',
              borderWidth: 1,
              tension: 0.6,
            },
          ],
        },
        options: {
          responsive: true,
        },
      });
    });
  }
}